module.exports = __webpack_public_path__ + "static/media/responsive.ab7d22e0.svg";